import { QuestionAnwserType } from "../types/enums/QuestionAnwserType";
import { Timeslots } from "../types/enums/Timeslots";
import { Question } from "../types/Question";
import { getMonthYearLabel } from "./date";

export const formatAnswer = (question: Question) => {
    if (!question.answer) return "-";

    switch (question.type) {
        case QuestionAnwserType.BOOLEAN:
            if (question.answer === "true") return "Oui";
            if (question.answer === "false") return "Non";
            return "-";
        case QuestionAnwserType.TIMESLOT:
            return (Timeslots as any)[question.answer] || question.answer;
        case QuestionAnwserType.DATE:
            const date = new Date(question.answer);
            return getMonthYearLabel(date);
        case QuestionAnwserType.STRING:
        default:
            return question.answer || "-";
    }
};
